import api from './api.js'

export const getSubscriptions = (page = 0, size = 20, status = '', search = '') => {
  const params = { page, size }
  if (status) params.status = status
  if (search) params.search = search
  return api.get('/admin/v1/subscriptions', { params })
}

export const getSubscriptionByEmail = (email) =>
  api.get('/admin/v1/subscriptions/by-email', { params: { email } })

export const getPaymentsByEmail = (email) =>
  api.get('/admin/v1/subscriptions/payments/by-email', { params: { email } })

export const grantPremium = (data) =>
  api.post('/admin/v1/subscriptions/grant', data)

export const updateSubscriptionStatus = (entitlementUuid, status) =>
  api.patch(`/admin/v1/subscriptions/${entitlementUuid}/status`, { status })

export const getSubscriptionStats = () =>
  api.get('/admin/v1/subscriptions/stats')
